import { render, staticRenderFns } from "./QuestionUploadFile.vue?vue&type=template&id=150d90b5&scoped=true&"
import script from "./QuestionUploadFile.vue?vue&type=script&lang=js&"
export * from "./QuestionUploadFile.vue?vue&type=script&lang=js&"
import style0 from "./QuestionUploadFile.vue?vue&type=style&index=0&id=150d90b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150d90b5",
  null
  
)

export default component.exports